
import React from 'react';
import OverviewSection from '../content/OverviewSection';
import ValuePropositionSection from '../content/ValuePropositionSection';
import SellerJourneySection from '../content/SellerJourneySection';
import BuyerJourneySection from '../content/BuyerJourneySection';
import BenefitsSection from '../content/BenefitsSection';

const ContentSections = () => {
  return (
    <>
      <OverviewSection />
      <ValuePropositionSection />
      <SellerJourneySection />
      <BuyerJourneySection />
      <BenefitsSection />
    </>
  );
};

export default ContentSections;
